import React, { useState } from 'react'
import { Card, CardContent, Grid, IconButton } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import Summary from './Summary'
import DownloadSummary from './DownloadSummary'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { semiConfigContext, ProductDetails } from '../Crisprgna'
import { ActiveLinkType, SpecificationMessages } from '../Enum'
import { crisprgrnaRoute, useRouter } from '@src/routes'
import { PriceCallResult, initialState } from '../Reducer'
import DeleteAllDialog from '@src/routes/Configurators/components/DeleteDialog'
import { priceFormatter } from '../../../../Configurators/utils/PriceFormatter'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TermsAndConditions from '@src/routes/Configurators/components/TermsAndConditions/TermsAndConditions'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { useCrisprgRnaPriceCallMutation } from '@src/mutations/SemiconfigCrisprgrnaMutation.generated'
import PerformanceGuaranteePopUp from '@src/routes/SemiConfigurators/components/PopUp/PerformanceGuaranteePopUp'

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(4, 5, 3.5),
      marginBottom: theme.spacing(4),
      borderRadius: 0,
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    subHead: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: theme.spacing(3, 0),
    },
    dFlex: {
      display: 'flex',
    },
    paddingFrScrollBar: {
      display: 'flex',
      paddingRight: theme.spacing(4.25),
    },
    tableContainer: {
      maxHeight: 880,
    },
    cardContent: {
      paddingBottom: theme.spacing(0),
      paddingRight: theme.spacing(0),
      '&.MuiCardContent-root': {
        padding: theme.spacing(0),
      },
    },
    deleteMargin: {
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(5),
    },
    label: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    deleteButton: {
      padding: theme.spacing(0),
    },
    deleteAllText: {
      fontSize: theme.typography.pxToRem(16),
    },
    sequenceInfo: {
      fontSize: theme.typography.pxToRem(16),
    },
    gridSytle: {
      paddingLeft: theme.spacing(9),
    },
    priceStyle: {
      fontSize: theme.typography.pxToRem(16),
      paddingLeft: theme.spacing(12.5),
    },
    quoteStyle: {
      fontSize: theme.typography.pxToRem(16),
      paddingLeft: theme.spacing(12.5),
      width: theme.spacing(35),
    },
    alignRight: {
      textAlign: 'right',
    },
    sequenceProperties: {
      '& + td': {
        paddingLeft: theme.spacing(5),
      },
    },
    gridPadding: {
      paddingLeft: theme.spacing(4),
    },
    recommendationText: {
      position: 'relative',
      marginTop: theme.spacing(5),
    },
    deleteIcon: {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.grey[400],
    },
  }
})

interface CrisprgRnaConfirmOrderProps {
  productDetails: ProductDetails
  currencyFormat: string
  thousandSeparator: any
  thousandSpacing: any
  prefixCurrecny: any
  decimalSeparator: any
}

const CrisprgRnaConfirmOrder: React.FC<CrisprgRnaConfirmOrderProps> = (
  props
) => {
  // This param is use to set CSS
  const classes = useStyles()
  const intl = useIntl()
  const router = useRouter()
  const [delType, setDelType] = useState('')
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [delItem, setDelItem] = useState()
  const [scrollBar, setScrollBar] = useState(false)
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [message, setMessage] = React.useState<string>('')

  // Setting state
  const { state, dispatch } = React.useContext(semiConfigContext)
  const { priceCallResponse } = state
  const [crisprgRnaPriceCall] = useCrisprgRnaPriceCallMutation()
  const {
    currencyFormat,
    thousandSeparator,
    thousandSpacing,
    prefixCurrecny,
    decimalSeparator,
  } = props

  const updateError = (value) => {
    setOpen(true)
    setMessage(value)
  }
  React.useEffect(() => {
    window.scrollTo(0, 0)
    if (state.priceCallData.reagents.length > 5) {
      setScrollBar(true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  const semiCrisprgrnaPriceCall = async (obj) => {
    const response: any = await crisprgRnaPriceCall({
      variables: { input: obj, productInput: props.productDetails },
    })
    if (response.data) {
      dispatch({
        type: 'UPDATE_PRICE_CALL_RESPONSE',
        data: response.data.crisprgRnaPriceCall,
      })
    }
  }

  // This method is use to perform delete all functionality
  const deleteOligoItem = (item: PriceCallResult, type) => {
    let isDeleteAll = false
    let isFinalItemDeleted = false

    const array = [...state.priceCallResponse.result]
    const index = array.indexOf(item)
    if (type === SpecificationMessages.Selected) {
      if (index !== -1) {
        array.splice(index, 1)
      }
      state.priceCallResponse.result = array
      dispatch({
        type: 'UPDATE_PRICE_CALL_RESPONSE',
        data: state.priceCallResponse,
      })

      // Fix for STRAT-10544 starts here
      dispatch({
        type: 'UPDATE_PRICE_CALL',
        data: {
          ...state.priceCallData,
          reagents: state.priceCallResponse.result,
        },
      })
      // Fix for STRAT-10544 ends here

      if (array.length === 0) {
        isFinalItemDeleted = true
      }

      if (array.length !== 0) {
        const priceCallInput = {
          ...state.priceCallData,
          reagents: state.priceCallResponse.result,
          country: props.productDetails.region,
        }
        semiCrisprgrnaPriceCall(priceCallInput)
      }
    } else if (type === SpecificationMessages.All) {
      isDeleteAll = true
    }

    if (isDeleteAll || isFinalItemDeleted) {
      if (state.stepNo === 3) {
        dispatch({ type: 'TRACE_ON_CLICK', data: true })
      }
      priceCallResponse.result = []
      dispatch({
        type: 'SET_INITIAL_STATE',
        data: initialState,
      })
      const url = `${crisprgrnaRoute.index()}?activeLink=${
        ActiveLinkType.ProductSearch
      }`
      if (!priceCallResponse.result.length) {
        router.push(url)
      }
    }
    if (state.priceCallResponse.result.length <= 5) {
      setScrollBar(false)
    }
  }

  const setTermsOpen = (value) => {
    setDialogOpen(value)
  }

  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelType(SpecificationMessages.Selected)
    setDelItem(item)
  }

  // This method is use to render data
  const renderData = () => {
    const result: any[] = []

    priceCallResponse.result.map((item, index) => {
      let priceStr = ''
      if (
        item.price &&
        item.price.toString() !== SpecificationMessages.quote &&
        item.price !== SpecificationMessages.ZeroPrice &&
        item.price.toString() !== '--'
      ) {
        priceStr = priceFormatter(
          item.price,
          currencyFormat,
          thousandSeparator,
          thousandSpacing,
          decimalSeparator,
          prefixCurrecny,
          item?.currencySymbol
        )
      } else if (
        item.price.toString() === SpecificationMessages.quote ||
        item.price === SpecificationMessages.ZeroPrice
      ) {
        priceStr = intl.formatMessage(messages._PC_QUOTE_ITEM)
      } else {
        priceStr = '--'
      }

      result.push(
        <Card className={classes.cardWrapper} key={index}>
          <CardContent className={classes.cardContent}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="flex-start"
            >
              <Grid item sm={5}>
                <div className={classes.sequenceInfo}>
                  <h4>
                    <strong>{item.grnaId ? item.grnaId : '-'}</strong>
                  </h4>
                </div>
              </Grid>
              <Grid item sm={4} className={classes.gridPadding}>
                <div>
                  <Table>
                    <tbody>
                      <tr>
                        <td className={classes.sequenceProperties}>
                          <strong>
                            <FormattedMessage
                              {...messages.CONF_GENE_ID_LABEL_crispgrna}
                            />
                            :
                          </strong>
                        </td>
                        <td>
                          <label>{item.geneId ? item.geneId : '-'}</label>
                        </td>
                      </tr>
                      <tr>
                        <td className={classes.sequenceProperties}>
                          <strong>
                            <FormattedMessage
                              {...messages.CONF_GENE_SYM_LABEL_crispgrna}
                            />
                            :
                          </strong>
                        </td>
                        <td>{item.geneSymbol ? item.geneSymbol : '-'}</td>
                      </tr>
                      <tr>
                        <td className={classes.sequenceProperties}>
                          <strong>
                            <FormattedMessage
                              {...messages.CONF_EFFICIENCY_SCORE_LABEL_crispgrna}
                            />
                            :
                          </strong>
                        </td>
                        <td>
                          <label>
                            {item.efficiencyScore ? item.efficiencyScore : '-'}
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td className={classes.sequenceProperties}>
                          <strong>
                            <FormattedMessage
                              {...messages.CONF_SPECIFICATION_SCORE_LABEL_crispgrna}
                            />
                            :
                          </strong>
                        </td>
                        <td>
                          <label>
                            {item.specificityScore
                              ? item.specificityScore
                              : '-'}
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td className={classes.sequenceProperties}>
                          <strong>
                            <FormattedMessage
                              {...messages.CONF_SPECIES_crisprgrna}
                            />
                            :
                          </strong>
                        </td>
                        <td>
                          <label>{item.species ? item.species : '-'}</label>
                        </td>
                      </tr>
                      <tr>
                        <td className={classes.sequenceProperties}>
                          <strong>
                            <FormattedMessage
                              {...messages.SEMICONF_RECOMMENDED_STATUS_crisprgrna}
                            />
                            :
                          </strong>
                        </td>
                        <td>
                          <label>
                            {item.recommendedStatus
                              ? item.recommendedStatus
                              : '-'}
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Grid>
              <Grid item sm={2}>
                <div
                  className={
                    priceStr === intl.formatMessage(messages._PC_QUOTE_ITEM)
                      ? classes.quoteStyle
                      : classes.priceStyle
                  }
                >
                  {priceStr}
                </div>
              </Grid>
              <Grid item sm={1} className={classes.alignRight}>
                <div>
                  <IconButton
                    aria-label="delete"
                    className={classes.deleteButton}
                    onClick={() => {
                      handleDelete(item)
                    }}
                  >
                    <DeleteIcon className={classes.deleteIcon} />
                  </IconButton>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )
      return item
    })
    return result
  }

  return (
    <>
      <div>
        <ErrorAlert open={open} setOpen={setOpen} message={message} />
      </div>
      <div className={classes.header}>
        <h3 className={classes.subHead}>
          <strong>
            <FormattedMessage {...messages.CONF_CONFIRM_ORDER_DNA_PLATES} />
          </strong>
        </h3>
        <div className={scrollBar ? classes.paddingFrScrollBar : classes.dFlex}>
          <h4>
            <strong className={classes.deleteAllText}>
              <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
            </strong>
          </h4>
          <span className={classes.deleteMargin}>
            <IconButton
              aria-label="delete"
              onClick={() => {
                setDelDialogOpen(true)
                setDelType('All')
                setDelItem(delItem)
              }}
              className={classes.deleteButton}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </span>
        </div>
      </div>
      <Grid item xs={6} className={classes.recommendationText}>
        <PerformanceGuaranteePopUp />
      </Grid>
      <TableContainer className={scrollBar ? classes.tableContainer : ''}>
        {renderData()}
      </TableContainer>
      <DownloadSummary />
      <Summary
        onDelete={deleteOligoItem}
        productDetails={props.productDetails}
        currencyFormat={props.currencyFormat}
        setTermsOpen={setTermsOpen}
        updateError={updateError}
        thousandSeparator={thousandSeparator}
        thousandSpacing={thousandSpacing}
        prefixCurrecny={prefixCurrecny}
        decimalSeparator={decimalSeparator}
      />
      <TermsAndConditions
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
      />
      <DeleteAllDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        type={delType}
        onDelete={deleteOligoItem}
      />
    </>
  )
}

export default CrisprgRnaConfirmOrder
